// extracted by mini-css-extract-plugin
module.exports = {"gif":"LocalStorageBlockedModal_gif__yT1uT","text":"LocalStorageBlockedModal_text__pboHJ"};